export default __webpack_public_path__ + "static/media/59cabb59-c25b-4082-a865-c5a9e90510bb.a1058440.webp";